import React from "react";
import Document from "./Document";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default ({ children }) => (
  <Document>
    {children}
  </Document>
);
